import React from 'react';
import { SEO } from '../components/layout/SEO';
import { Section } from '../components/ui/Section';
import { Card, CardContent } from '../components/ui/Card';
import { FadeIn } from '../components/ui/FadeIn';
import { Mail, Users, AlertCircle } from 'lucide-react';
export function TeamPage() {
  const kmaCouncil = [{
    name: 'Syed Amjad Ali',
    role: 'President'
  }, {
    name: 'Zia ur Rahman',
    role: 'General Secretary'
  }, {
    name: 'Miraman Khan',
    role: 'Finance Director'
  }];
  const executiveCommittee = ['Saeed ur Rahman', 'Akbar Ali', 'Sulaiman Shoaib', 'Aimen Fazal Maula', 'Ilamdad Khan', 'Ayaz Shah'];
  const advisoryBoard = ['Dr Tahir Khattak', 'Mr Naved Alizai', 'Dr Naim Khan', 'Dr Shahid Khan', 'Mr Syed Amjad', 'Dr Shaheena Altaf', 'Dr Mazhar Arbab'];
  return <>
      <SEO title="Team" description="Meet the leadership team of KMA UK" data-id="element-714" />

      <div className="bg-[#1e5f4f] text-white py-16 md:py-20" data-id="element-715">
        <div className="container mx-auto px-4 text-center" data-id="element-716">
          <FadeIn data-id="element-717">
            <Users className="h-12 w-12 mx-auto mb-6 text-white" data-id="element-718" />
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-719">
              Our Leadership Team
            </h1>
            <p className="text-xl text-white max-w-2xl mx-auto" data-id="element-720">
              Dedicated professionals volunteering their time and expertise to
              serve our community and advance our charitable mission.
            </p>
          </FadeIn>
        </div>
      </div>

      {/* Note */}
      <Section data-id="element-721">
        <div className="max-w-4xl mx-auto" data-id="element-722">
          <FadeIn data-id="element-723">
            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 rounded-r-lg flex items-start gap-3" data-id="element-724">
              <AlertCircle className="h-6 w-6 text-blue-600 shrink-0 mt-0.5" data-id="element-725" />
              <p className="text-gray-800 leading-relaxed" data-id="element-726">
                <strong data-id="element-727">Note:</strong> Profiles and photos will be added soon.
              </p>
            </div>
          </FadeIn>
        </div>
      </Section>

      {/* KMA Council */}
      <Section background="gray" data-id="element-728">
        <div className="max-w-4xl mx-auto" data-id="element-729">
          <FadeIn data-id="element-730">
            <h2 className="text-3xl font-serif font-bold text-primary-900 mb-8 text-left" data-id="element-731">
              KMA Council
            </h2>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-732">
            {kmaCouncil.map((member, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-733">
                <Card className="h-full shadow-md" data-id="element-734">
                  <CardContent className="p-6 text-center" data-id="element-735">
                    <div className="h-20 w-20 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-2xl font-bold mb-4 mx-auto" data-id="element-736">
                      {member.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-737">
                      {member.name}
                    </h3>
                    <p className="text-primary-700 font-semibold text-sm uppercase tracking-wide" data-id="element-738">
                      {member.role}
                    </p>
                  </CardContent>
                </Card>
              </FadeIn>)}
          </div>
        </div>
      </Section>

      {/* Executive Committee */}
      <Section data-id="element-739">
        <div className="max-w-4xl mx-auto" data-id="element-740">
          <FadeIn data-id="element-741">
            <h2 className="text-3xl font-serif font-bold text-primary-900 mb-8 text-left" data-id="element-742">
              Executive Committee
            </h2>
          </FadeIn>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-743">
            {executiveCommittee.map((name, i) => <FadeIn key={i} delay={i * 0.05} data-id="element-744">
                <Card className="shadow-sm" data-id="element-745">
                  <CardContent className="p-5 flex items-center gap-3" data-id="element-746">
                    <div className="h-12 w-12 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center text-lg font-bold shrink-0" data-id="element-747">
                      {name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div data-id="element-748">
                      <p className="font-semibold text-gray-900" data-id="element-749">{name}</p>
                    </div>
                  </CardContent>
                </Card>
              </FadeIn>)}
          </div>
        </div>
      </Section>

      {/* Advisory Board */}
      <Section background="gray" data-id="element-750">
        <div className="max-w-4xl mx-auto" data-id="element-751">
          <FadeIn data-id="element-752">
            <h2 className="text-3xl font-serif font-bold text-primary-900 mb-8 text-left" data-id="element-753">
              Advisory Board
            </h2>
          </FadeIn>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-754">
            {advisoryBoard.map((name, i) => <FadeIn key={i} delay={i * 0.05} data-id="element-755">
                <Card className="shadow-sm" data-id="element-756">
                  <CardContent className="p-5 flex items-center gap-3" data-id="element-757">
                    <div className="h-12 w-12 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-lg font-bold shrink-0" data-id="element-758">
                      {name.split(' ').filter(n => n !== 'Dr' && n !== 'Mr').map(n => n[0]).join('')}
                    </div>
                    <div data-id="element-759">
                      <p className="font-semibold text-gray-900" data-id="element-760">{name}</p>
                    </div>
                  </CardContent>
                </Card>
              </FadeIn>)}
          </div>
        </div>
      </Section>

      {/* Charity Number */}
      <Section className="py-8 border-t border-gray-100" data-id="element-761">
        <div className="text-center text-gray-500 text-sm" data-id="element-762">
          <p data-id="element-763">Registered Charity Number: 1097262</p>
        </div>
      </Section>

      {/* Contact CTA */}
      <Section className="text-center pt-0" data-id="element-764">
        <FadeIn data-id="element-765">
          <div className="max-w-2xl mx-auto" data-id="element-766">
            <Mail className="h-10 w-10 mx-auto mb-4 text-primary-600" data-id="element-767" />
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-768">
              Get in Touch with Our Team
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-769">
              Have questions about our work or interested in collaborating? We'd
              love to hear from you.
            </p>
            <div className="bg-gray-50 rounded-lg p-6 inline-block" data-id="element-770">
              <p className="text-sm text-gray-600 mb-2" data-id="element-771">General Inquiries</p>
              <a href="mailto:info@kmauk.org" className="text-lg font-semibold text-primary-700 hover:underline" data-id="element-772">
                info@kmauk.org
              </a>
            </div>
          </div>
        </FadeIn>
      </Section>
    </>;
}